import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, Loader2, UtensilsCrossed } from "lucide-react";
import { http, apiError } from "@/lib/api";
import { ADMIN_BASE } from "@/lib/config";
import ThemeScope from "@/components/ThemeScope";
import { PRESETS } from "@/lib/themes";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [branding, setBranding] = useState({
    admin_panel_name: "Admin Panel",
    app_name: "Order App",
    app_icon_url: "",
  });

  useEffect(() => {
    if (localStorage.getItem("wm_token")) nav(ADMIN_BASE);

    http.get("/branding/public")
      .then(({ data }) => {
        setBranding((prev) => ({ ...prev, ...data }));
        document.title = data.admin_panel_name || "Admin Panel";
      })
      .catch(() => {});
  }, []);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("wm_token", data.token);
      toast.success(`Selamat datang, ${data.user.name}`);
      nav(ADMIN_BASE);
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  }

  return (
    <ThemeScope tokens={PRESETS.midnight_noodle.tokens} className="min-h-dvh">
      <div className="flex min-h-dvh items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-border bg-card p-7">
          <div className="grid h-12 w-12 place-items-center overflow-hidden rounded-2xl bg-primary text-primary-foreground">
            {branding.app_icon_url ? (
              <img src={branding.app_icon_url} alt="" className="h-full w-full object-cover" />
            ) : (
              <UtensilsCrossed size={22} />
            )}
          </div>
          <h1 className="mt-5 font-heading text-3xl font-extrabold tracking-tight text-card-foreground">{branding.admin_panel_name || "Admin Panel"}</h1>
          <p className="mt-1 text-sm text-muted-foreground">Kelola menu, pesanan, dan tampilan kedai.</p>
          <div className="mt-6 space-y-3">
            <label className="flex items-center gap-3 rounded-2xl border border-border bg-muted px-4">
              <Mail size={18} className="text-muted-foreground" />
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
                className="w-full bg-transparent py-3.5 text-sm outline-none" />
            </label>
            <label className="flex items-center gap-3 rounded-2xl border border-border bg-muted px-4">
              <Lock size={18} className="text-muted-foreground" />
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
                className="w-full bg-transparent py-3.5 text-sm outline-none" />
            </label>
          </div>
          <button data-testid="login-submit" disabled={busy}
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-primary py-3.5 font-bold text-primary-foreground transition-transform active:scale-95 disabled:opacity-50">
            {busy ? <Loader2 className="wm-spin" size={18} /> : "Masuk"}
          </button>
        </form>
      </div>
    </ThemeScope>
  );
}
